import loggedReducer from "./isLogged";
import {combineReducers} from 'redux'
import fixturesReducer from "./fixturs";
import userDetailsReducer from "./userDetails";
import questionReducer from "./question";
import leaderBoardReducer from "./leaderBoarder";
import siteStatusReducer from "./siteStatus";
import weekDaysReducer from "./weekDays";
import leaderboardTabReducer from "./leaderboardTab";
import settingsReducer from "./settings";

const allReducers = combineReducers({
        isLogged:loggedReducer,
        fixtures:fixturesReducer,
        userData:userDetailsReducer,
        questionData:questionReducer,
        leaderboard:leaderBoardReducer,
        siteStatus: siteStatusReducer,
        weekDays: weekDaysReducer,
        leaderboardTab:leaderboardTabReducer,
        settings: settingsReducer
})

export default allReducers;